<template>
  <div class="e-scroll-container" v-loading="isLoadingPrivacyConsent">
    <VuePerfectScrollbar class="e-content__inner">
      <div class="e-content__scroll">
        <div class="e-module e-module--limited e-module--left">
          <div v-if="privacyConsent" class="e-form__content">
            <div v-html="privacyConsent.text" class="privacy-consent-text" />
            <div class="radio-form-item">
              <input id="one" v-model="radio" type="radio" value="1" />
              <label for="one">
                {{ privacyConsent.yes }}
              </label>
            </div>
            <div class="radio-form-item">
              <input id="two" v-model="radio" type="radio" value="0" />
              <label for="two">
                {{ privacyConsent.no }}
              </label>
            </div>
            <div class="e-form__row e-form__row--submit">
              <el-button style="visibility:hidden" />
              <el-button :disabled="disabled" :loading="loading" native-type="submit" type="tertiary" @click="gdprClick">
                Absenden
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { userActions } from 'mixins'
import { mapActions, mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  mixins: [userActions],
  data () {
    return {
      loading: false,
      radio: -1
    }
  },
  computed: {
    ...mapGetters(['privacyConsent', 'isLoadingPrivacyConsent']),
    gdprVersion () {
      return format((new Date(window.gdprVersion)).getTime(), 'dd.MM.yyyy')
    },
    disabled () {
      return this.radio === -1
    }
  },
  created () {
    this.loadPrivacyConsent()
  },
  methods: {
    ...mapActions(['loadPrivacyConsent']),
    async gdprClick () {
      if (this.radio === '0') {
        this.$confirm(
          this.privacyConsent.confirmation,
          this.$t('system.warning'),
          {
            confirmButtonText: this.$t('system.confirm'),
            cancelButtonText: this.$t('system.cancel'),
            type: 'warning'
          }
        ).then(async () => {
          await this.__user__deleteAccount()
          this.__user__logout()
        })
        return
      }
      await this.__user__confirmGdpr()
      this.$router.push({ name: 'loginLanding' })
    }
  }
}
</script>

<style lang="scss">
.mb-auto {
  margin-bottom: auto;
}

.privacy-consent-text {
  margin-bottom: 32px;
}

.radio-form-item {
  display: flex;
  margin-bottom: 20px;

  input {
    width: 16px;
    min-width: 16px;
  }

  label {
    margin-left: 15px;
  }
}
</style>
